import React, { useContext } from 'react'
import { context } from '@/Layout'
import { get } from 'lodash'
import useStore from '../../../hooks/useStore'
import './styles.scss'
import InstagramIconSvg from './icons/instagram'

export default function Footer() {
  const { acfOptions } = useStore()
  const siteOptions = acfOptions()
  const { appState } = useContext(context)

  const menusFooter = get(appState, ['menus', 'footer-menu'], [])

  const website_links = Array.isArray(menusFooter)
    ? menusFooter.filter((x) => !x?.acf?.is_external_link)
    : []
  const external_links = Array.isArray(menusFooter)
    ? menusFooter.filter((x) => x?.acf?.is_external_link)
    : []
  // console.log(website_links)
  const footer_info = siteOptions?.footer_info ?? {}
  // const { brand_section, lin } = footer_info
  const footer_data = {
    brand_section: footer_info?.brand_section ?? {
      brand_image: {
        link: '/wp-content/uploads/2024/05/logo-aic-footer.png',
      },
      brand_title: '',
      line_content_one: '',
      line_content_two: '',
    },
    footer_internal_link_block: footer_info?.footer_internal_link_block,
    footer_external_link_block: footer_info?.footer_external_link_block,
    social_media_links: footer_info?.social_media_links,
    bottom_content: footer_info?.bottom_content ?? '',
    link_and_social: footer_info?.link_and_social ?? {
      link_content_block: [],
    },
  }

  return (
    <div id="site-footer" className="footer pt-spacing-lg pb-spacing-md">
      <div className="main-footer-container">
        <div className="footer-top-container">
          <div className="brand-container">
            <div className="footer-logo-title">
              <img src={footer_data.brand_section?.brand_image?.link} alt="AIC Hotel Footer logo" />
              <h2>{footer_data.brand_section?.brand_title}</h2>
            </div>
            <div className="brand-container-content">
              <p>{footer_data.brand_section.line_content_one}</p>
              <p>{footer_data.brand_section.line_content_two}</p>
            </div>
          </div>
          <div className="footer-link-block">
            <h2 className="heading4 font-halyard">
              {footer_data.footer_internal_link_block?.block_title ?? ''}
            </h2>
            <div className="footer-page-link">
              {website_links.map((page_link, index) => {
                return (
                  <a href={page_link.url} target={page_link.target} key={index}>
                    {String(page_link.content).replace(/&amp;/g, '&')}
                  </a>
                )
              })}
            </div>
          </div>
          <div className="footer-link-block">
            <h2 className="heading4 font-halyard">
              {footer_data.footer_external_link_block?.block_title ?? ''}
            </h2>
            <div className="footer-page-link">
              {external_links.map((page_link, index) => {
                return (
                  <a href={page_link.url} target={page_link.target} key={index}>
                    {String(page_link.content).replace(/&amp;/g, '&')}
                  </a>
                )
              })}
            </div>
          </div>
          <div className="footer-link-media">
            <h2 className="heading4 font-halyard">Social</h2>
            <div className="footer-page-link">
              <a href={'https://www.instagram.com/aichotelgroup/'} target="_blank" rel="noreferrer">
                <InstagramIconSvg />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom-container">
          <hr />
          <p>{footer_data.bottom_content}</p>
        </div>
      </div>
    </div>
  )
}
